// components/AboutSection.jsx
import SectionReveal from './SectionReveal';
import logo from '../assets/logodark.png';
import AboutPhoto from '../assets/about.png';

const socialLinks = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/share/1Fzs4GyAxY/',
    hoverColor: 'hover:bg-[#0FA4E8] ',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    )
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/nwt.am?igsh=MTQwcjdiYzM1MXU0aQ==',
    hoverColor: 'hover:bg-[#0FA4E8] ',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    )
  },
  {
    name: 'YouTube',
    url: 'https://youtube.com/@nationalwatertechnologyarmenia?si=RY4lHcbUdkjoPqwr',
    hoverColor: 'hover:bg-[#0FA4E8] ',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    )
  }
];

export default function AboutSection({ t }) {
  return (
    <section id="about" className="relative bg-white px-3 py-6 md:px-10 shadow-nwta">
      
      <div className="mx-auto max-w-7xl space-y-12">
        
        {/* Блок 1: О нас */}
        <SectionReveal>
          <div className="md:border-l-4 border-l-2 border-[#0FA4E8] bg-gray-50 p-5 md:p-10">
            
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
              <img src={logo} alt="NWTA" className="w-44 object-contain" />
              
              {/* Соцсети с названиями */}
              <div className="flex items-center gap-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex items-center gap-2 text-sm font-bold text-[#0B3B6F] transition-all duration-300 group`}
                    aria-label={social.name}
                  >
                    <span className={`flex items-center justify-center w-10 h-10 border border-gray-200 ${social.hoverColor} hover:text-white transition-all duration-300`}>
                      {social.icon}
                    </span>
                    <span className="hidden lg:inline group-hover:text-[#0FA4E8] transition-colors">{social.name}</span>
                  </a>
                ))}
              </div>
            </div>
            
            <h2 className="text-xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-4">
              {t.aboutFocusTitle}
            </h2>
            <p className="text-base md:text-lg text-slate-600 leading-relaxed">
              {t.aboutFocusText}
            </p>
          </div>
        </SectionReveal>

        {/* Блок 2: Текст слева + Фото справа */}
        <SectionReveal delay={150}>
          <div className="grid gap-0 md:grid-cols-5 md:border-l-4 border-l-2 border-[#0B3B6F] overflow-hidden">
            
            {/* Левая часть - преимущества */}
            <div className="md:col-span-3 bg-gray-50 p-5 md:p-10">
              <h3 className="text-lg md:text-xl font-black text-[#0B3B6F] uppercase mb-6">
                {t.aboutWhatSetsUsApart}
              </h3>
              <div className="grid gap-3 sm:grid-cols-2">
                {t.aboutHighlights.map((item, idx) => (
                  <div key={idx} className="flex items-start gap-3 p-4 bg-white border border-gray-100 hover:border-[#0FA4E8]/30 transition-all group">
                    <span className="flex-shrink-0 mt-0.5 text-[#0FA4E8]">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                    </span>
                    <span className="text-sm font-semibold text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors">
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Правая часть - фото */}
            <div className="md:col-span-2 relative min-h-[300px] group overflow-hidden">
              <div 
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                style={{ backgroundImage: `url(${AboutPhoto})` }}
              />
              <div className="absolute inset-0 bg-[#0B3B6F]/20" />
            </div>

          </div>
        </SectionReveal>

      </div>
    </section>
  );
}